import { Kundeavis } from "/react4xp/parts/kundeavis/kundeavis"

export default (props) => <Kundeavis {...props} />
